/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ reason: NonNullable<unknown> }} Private_Models_Last_ErrorInputs */



/**
* | output |
* | --- |
* | "Last check failed: {reason}" |
*
* @param {Private_Models_Last_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const private_models_last_error = /** @type {((inputs: Private_Models_Last_ErrorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Private_Models_Last_ErrorInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Letzte Prüfung fehlgeschlagen: ${i?.reason}`)
	return /** @type {LocalizedString} */ (`Last check failed: ${i?.reason}`)
});